import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from './index';
import { cn } from '../../utils';
export function TabsSkeleton({ count = 4, widths = [100, 160, 160, 100], className, }) {
    return (_jsx("div", { className: cn('flex gap-stack-tight', className), children: Array.from({ length: count }).map((_, index) => (_jsx(Skeleton, { width: widths[index] ?? 100, height: 32, borderRadius: 16 }, index))) }));
}
